module.exports = __webpack_public_path__ + "aa19ae6122aa4f06cced8aa2ce536940.woff2";